<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="dedication" id="_idContainer000" role="doc-dedication">
<p class="pl-center">This story is dedicated to all the true heroes in the world—men and women who risk their lives for others.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?709c1c4c